// src/lib/watchlistClient.js — frontend helpers for Watchlist v3.
//
// Wraps /api/watchlist so React components don't need to know about the
// action= query-string protocol. user_id is passed in by callers; resolve it
// from Clerk at the call site (useUser().user.id).

const ENDPOINT = '/api/watchlist';

async function call(action, init = {}) {
  const url = `${ENDPOINT}?action=${encodeURIComponent(action)}${
    init._extraQs ? `&${init._extraQs}` : ''
  }`;
  const { _extraQs, ...fetchInit } = init;
  const r = await fetch(url, fetchInit);
  if (!r.ok) {
    const text = await r.text().catch(() => '');
    throw new Error(`watchlist ${action} ${r.status}: ${text}`);
  }
  return r.json();
}

const post = (action, body) => call(action, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

const get = (action, query) => call(action, { _extraQs: new URLSearchParams(query).toString() });

// ── reads ───────────────────────────────────────────────────────────────────

export const getUserLists      = (userId) => get('lists', { user_id: userId });
export const getUserPref       = (userId, key) => get('pref', { user_id: userId, key });

// ── writes ──────────────────────────────────────────────────────────────────

export const createList        = (userId, name, position) => post('create-list', { user_id: userId, name, position });
export const renameList        = (listId, name) => post('rename-list', { list_id: listId, name });
export const deleteList        = (listId) => post('delete-list', { list_id: listId });
export const addStockToList    = (listId, ticker) => post('add-stock', { list_id: listId, ticker });
export const removeStockFromList = (listId, ticker) => post('remove-stock', { list_id: listId, ticker });
export const setUserPref       = (userId, key, value) => post('set-pref', { user_id: userId, key, value });

// (The labs-era helpers — follow/unfollow/reorder/touch/_internal.migrate —
// were deleted 2026-08-15; the Labs feature died with V1.)
